import { CATALOGS, type Lang } from '@/i18n'

/** Bitta i18n kalit (yassilangan yo'l) + har til qiymati. `fn`=funksiya-qiymat
 *  (parametrli matn, masalan `banTitle(name)`) — u tarjima-tekshiruvidan chiqariladi. */
export interface CatalogEntry {
  key: string
  en: string
  ru: string
  uz: string
  fn: boolean
}

function walk(obj: unknown, prefix: string, out: Map<string, Partial<Record<Lang, unknown>>>, lang: Lang): void {
  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
      walk(v, prefix ? `${prefix}.${k}` : k, out, lang)
    }
  } else {
    const e = out.get(prefix) ?? {}
    e[lang] = obj
    out.set(prefix, e)
  }
}

/** Barcha kataloglarни (uz/ru/en) yassilaydi va kalit bo'yicha tekislaydi. */
export function catalogEntries(): CatalogEntry[] {
  const map = new Map<string, Partial<Record<Lang, unknown>>>()
  for (const lang of Object.keys(CATALOGS) as Lang[]) walk(CATALOGS[lang], '', map, lang)
  const rows: CatalogEntry[] = []
  for (const [key, vals] of map) {
    const fn = typeof vals.en === 'function' || typeof vals.ru === 'function' || typeof vals.uz === 'function'
    rows.push({
      key,
      en: fn ? '(fn)' : String(vals.en ?? ''),
      ru: fn ? '(fn)' : String(vals.ru ?? ''),
      uz: fn ? '(fn)' : String(vals.uz ?? ''),
      fn,
    })
  }
  rows.sort((a, b) => a.key.localeCompare(b.key))
  return rows
}

/** Top-daraja nom-maydoni (kalitning birinchi segmenti). */
export const namespaceOf = (key: string): string => key.split('.')[0] || '—'
